import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

/**
 * Small logout pill. Renders only when the user is authenticated.
 * Drop it into any page header/toolbar.
 */
export default function LogoutButton({ variant = "pill", className = "" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAuthed = !!(user && user !== false);
  if (!isAuthed) return null;

  const doLogout = async () => {
    await logout();
    toast.success("Signed out. The room stays here.");
    navigate("/", { replace: true });
  };

  if (variant === "icon") {
    return (
      <button
        onClick={doLogout}
        data-testid="global-logout-btn"
        className={`p-2 rounded-full text-stone-400 hover:text-rose-300 hover:bg-rose-950/40 transition-all ${className}`}
        aria-label="Log out"
        title="Log out"
      >
        <LogOut className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      onClick={doLogout}
      data-testid="global-logout-btn"
      className={`inline-flex items-center gap-2 rounded-full bg-stone-900/70 border border-stone-800 hover:border-rose-500/60 text-stone-300 hover:text-rose-200 px-3 py-1.5 text-sm transition-all ${className}`}
    >
      <LogOut className="w-4 h-4" />
      <span className="hidden sm:inline">Log out</span>
    </button>
  );
}
